import * as React from 'react';

import {UsageFooter} from 'shells/navigation/secondary-sidebar/usage-footer-new';

import {appHistory} from '../../../history';

import {SmsTrialModal} from '../../inbox/sms/sms-trial-modal';
import {useGetInboxStatus} from '../../setup/text-messaging/graphql/hooks';

// The unlock percentage point in which we promote a plan upgrade
const APPROACHING_LIMIT_PERCENT = 0.9;

type Props = {
    type: 'inbox' | 'smsCampaigns';
};

export function InboxCreditUsageFooter(props: Props) {
    const {inboxStatus} = useGetInboxStatus();

    const [showUpsell, setShowUpsell] = React.useState(false);

    if (!inboxStatus) {
        return null;
    }

    const monthlyLimit = inboxStatus.planStatus.monthlyCredits;
    const usedThisMonth = inboxStatus.planStatus.usedCredits;

    const featureGated =
        (!NutClientConfig.hasSmsCampaignsFeature && props.type === 'smsCampaigns') ||
        NutClientConfig.isTrial ||
        (props.type === 'inbox' && inboxStatus.planStatus.status === 'NO_PLAN');

    return (
        <>
            <UsageFooter
                type={props.type}
                usage={usedThisMonth}
                limit={monthlyLimit}
                approachingLimitPercent={APPROACHING_LIMIT_PERCENT}
                isBeta={NutClientConfig.hasNutshellInboxBeta}
                featureGated={featureGated}
                onClickFeatureGate={() => {
                    if (props.type === 'inbox') {
                        setShowUpsell(true);
                    } else if (props.type === 'smsCampaigns') {
                        appHistory.push('/setup/billing/sales');
                    }
                }}
            />
            {featureGated && props.type === 'inbox' && (
                <SmsTrialModal isOpen={showUpsell} onClose={() => setShowUpsell(false)} />
            )}
        </>
    );
}
